<template>
  <div>
    <transition name="fade">
      <div class="window">
        <div class="content" v-if="loaded">
          <div class="popup bsod">
            <h1 class="neg title">
              <span class="bg">{{ instru.title }}</span>
            </h1>
            <div>{{ instru.text }}</div>
            <div class="files">
              <div class="col">
                <h3>care package</h3>
                <ol>
                  <li
                    v-for="release in instru.releases"
                    :key="release.id"
                    @click="showTracks(release)"
                  >
                    {{ release.title }}
                  </li>
                </ol>
              </div>
              <div class="col middle">
                <h3>track</h3>
                <ul >
                  <div v-if="tracks !== null">
                    <li
                      v-for="track in tracks"
                      :key="track.id"
                      @click="showStems(track)"
                    
                    >
                      {{ track.name + " (" + track.artist + ")"}}
                    </li>
                  </div>
                  <div v-else>
                    <li>please select a release</li>
                  </div>
                </ul>
              </div>
              <div class="col">
                <h3>stems</h3>
                <h4 v-if="stems !== null">{{ selected.name + " (" + selected.artist + ")"}}</h4>
                <ul>
                  <div v-if="stems !== null" class="div-list">
                  <li v-for="stem in stems" :key="stem.id">
                    <a :href="stem.link" target="_blank">{{ stem.name }}</a>
                  </li>
                  </div>
                  <div v-else>
                    <li>please select a track</li>
                  </div>
                </ul> 
              </div>
            </div>
            <nav class="nav">
              <a class="link" @click="closePopup()">CLOSE</a>
            </nav>
          </div>
        </div>
        <div v-else style="position: absolute; top: -33vh; left: 50%;">
          <Loader></Loader>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from "@/components/utilities/Loader.vue";
export default {
  name: "Beats",
  components: {
    Loader,
  },
  props: ["instru"],
  data() {
    return {
      loaded: false,
      tracks: null,
      stems: null,
      selected: null
    };
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    showTracks(release) {
      this.tracks = release.tracks;
    },
    showStems(track) {
      this.selected = track;
      this.stems = track.stems;
    },
  },
  mounted() {
    setTimeout(() => (this.loaded = true), 2000);
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/landing-error.scss";
ol, ul {
  list-style: none;
  padding: 0;
}

.div-list{
  max-height: 25vh;
  overflow: scroll;
}

.window {
  position: absolute;
  min-width: 100vw;
  min-height: 100vh;
  top: 0;
  left: -1vh;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
}

.content {
  z-index: 2;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}

.popup {
  display: inline-block;
  bottom: 40px;
  width: 70%;
  height: 90vh;
  text-align: center;
  overflow: scroll;
  padding-top: 5vh;
  margin: auto;
}

.nav {
  margin-top: 35px;
  text-align: center;

  .link {
    text-decoration: none;
    padding: 0 9px 2px 8px;

    &:hover,
    &:focus {
      background: $grey;
      color: $blue;
    }
  }
}

.files {
  display: flex;
  height: 60%;
}

.col {
  flex: 1;
  height: 100%;
  background-color: rgba(0, 31, 167, 0.5);
  border-radius: 20px;
  margin: 5px;
  max-width: 25%;
}

.middle{
  flex:2;
  max-width: 50%;
}

li:hover{
  background-color: $grey;
  color: $blue;
}
</style>
